export default __webpack_public_path__ + "static/media/TurboBlue.f65cf11a.svg";